var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"81a9e072be932a70690956ca609e048159d12eaa"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["agt-guntrade@cronit"]={id:"81a9e072be932a70690956ca609e048159d12eaa"};
      